module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image02.b185a21b.jpg";